{
  "nl": {
    "pagination": {
      "next": "Volgende pagina",
      "page_report": "Pagina {page} van {total}",
      "previous": "Vorige pagina",
      "report": "Toon {first} tot {last} van {total}",
      "total": "Totaal aantal items: {total}"
    }
  }
}
